document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('ai-tool-finder-modal');
  if (!modal) return;

  var DEBUG = typeof URLSearchParams !== 'undefined'
    && new URLSearchParams(window.location.search).has('atf_debug');

  // ── DOM refs ─────────────────────────────────────────────────────────────────

  var openBtn        = document.getElementById('ai-tool-finder-open');
  var mobileOpenBtn  = document.getElementById('ai-tool-finder-open-mobile');
  var form           = document.getElementById('ai-tool-finder-form');
  var jobInput       = document.getElementById('ai-tool-finder-job');
  var exampleButtons = modal.querySelectorAll('.ai-tool-finder__example-btn');
  var responseEmpty      = modal.querySelector('.ai-tool-finder__response--empty');
  var responseLoading    = modal.querySelector('.ai-tool-finder__response--loading');
  var responseError      = modal.querySelector('.ai-tool-finder__response--error');
  var responseResults    = modal.querySelector('.ai-tool-finder__response--results');
  var responseNoResults  = modal.querySelector('.ai-tool-finder__response--no-results');
  var resultsHeading = document.getElementById('ai-tool-finder-results-heading');
  var resultsLink    = document.getElementById('ai-tool-finder-results-link');
  var errorLink      = document.getElementById('ai-tool-finder-error-link');
  var noResultsLink  = document.getElementById('ai-tool-finder-no-results-link');
  var brandNote          = document.getElementById('ai-tool-finder-brand-note');
  var placeholderImgUrl  = modal.dataset.placeholderImg || '';

  var cats = {
    recommended: { section: document.getElementById('atf-cat-recommended'), grid: document.getElementById('atf-grid-recommended') },
    promotions:  { section: document.getElementById('atf-cat-promotions'),   grid: document.getElementById('atf-grid-promotions') },
    featured:    { section: document.getElementById('atf-cat-featured'),     grid: document.getElementById('atf-grid-featured') }
  };

  var ANALYTICS_KEY = 'atf-analytics';
  var lastQuery            = '';
  var currentIntentLabel   = '';
  var currentBrand         = '';
  var currentTrade         = '';
  var currentBudget        = '';
  var currentBudgetData    = null;
  var currentQualityIntent = null;

  // ── Modal state ───────────────────────────────────────────────────────────────

  function setModalOpen(isOpen) {
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', String(isOpen));
    if (mobileOpenBtn) mobileOpenBtn.setAttribute('aria-expanded', String(isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
    if (isOpen) {
      window.requestAnimationFrame(function () { if (jobInput) jobInput.focus(); });
    }
  }

  function setResponseState(state) {
    if (responseEmpty)     responseEmpty.hidden     = state !== 'empty';
    if (responseLoading)   responseLoading.hidden   = state !== 'loading';
    if (responseError)     responseError.hidden     = state !== 'error';
    if (responseResults)   responseResults.hidden   = state !== 'results';
    if (responseNoResults) responseNoResults.hidden = state !== 'no-results';
  }

  function updateSearchLinks(query) {
    var href = '/search?q=' + encodeURIComponent(query);
    if (resultsLink)  resultsLink.href  = href;
    if (errorLink)    errorLink.href    = href;
    if (noResultsLink) noResultsLink.href = href;
  }

  // ── Helpers ───────────────────────────────────────────────────────────────────

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function shopifyImgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  // ── Bonus & featured detection from product tags ──────────────────────────────

  var BONUS_TAG_MAP = {
    'hot deal':      { type: 'Hot Deal',      score: 8, emoji: '🔥', color: '#EA580C', bg: '#FFF7ED' },
    'hot-deal':      { type: 'Hot Deal',      score: 8, emoji: '🔥', color: '#EA580C', bg: '#FFF7ED' },
    'bonus':         { type: 'Bonus',         score: 6, emoji: '🎁', color: '#2563EB', bg: '#EFF6FF' },
    'bonus offer':   { type: 'Bonus',         score: 6, emoji: '🎁', color: '#2563EB', bg: '#EFF6FF' },
    'limited stock': { type: 'Limited Stock', score: 5, emoji: '⚠️',  color: '#DC2626', bg: '#FEF2F2' },
    'limited-stock': { type: 'Limited Stock', score: 5, emoji: '⚠️',  color: '#DC2626', bg: '#FEF2F2' },
    'pre-order':     { type: 'Pre-Order',     score: 3, emoji: '📦', color: '#9333EA', bg: '#FAF5FF' },
    'pre order':     { type: 'Pre-Order',     score: 3, emoji: '📦', color: '#9333EA', bg: '#FAF5FF' },
    'redemption':    { type: 'Redemption',    score: 2, emoji: '🏷️', color: '#16A34A', bg: '#F0FDF4' }
  };

  function detectBonusFromTags(tags) {
    if (!tags || !tags.length) return null;
    for (var i = 0; i < tags.length; i++) {
      var tl = tags[i].toLowerCase();
      if (BONUS_TAG_MAP[tl]) return BONUS_TAG_MAP[tl];
    }
    return null;
  }

  function detectFeaturedFromTags(tags) {
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      var tl = tags[i].toLowerCase();
      if (tl === 'featured' || tl === 'featured product' || tl === 'featured-product') return true;
    }
    return false;
  }

  // ── Vendor data quality ──────────────────────────────────────────────────────

  var INVALID_VENDORS = ['#n/a', 'n/a', 'unknown', ''];

  function isValidVendor(vendor) {
    if (!vendor && vendor !== 0) return false;
    return INVALID_VENDORS.indexOf(vendor.toString().trim().toLowerCase()) === -1;
  }

  function getDisplayVendor(vendor) {
    return isValidVendor(vendor) ? vendor : 'VEK Tools';
  }

  // ── Confidence scoring ───────────────────────────────────────────────────────

  var CONFIDENCE_MAX = 25;

  function getConfidence(score) {
    var pct = Math.min(Math.round(score / CONFIDENCE_MAX * 100), 100);
    if (pct >= 90) return { label: 'Best Match',        emoji: '🏆', cls: 'atf-confidence--best'   };
    if (pct >= 70) return { label: 'Strong Match',      emoji: '✓',  cls: 'atf-confidence--strong' };
    if (pct >= 50) return { label: 'Good Match',        emoji: '✓',  cls: 'atf-confidence--good'   };
    return           { label: 'Alternative Option', emoji: '',   cls: 'atf-confidence--alt'    };
  }

  // ── Budget extraction ────────────────────────────────────────────────────────

  function extractBudget(query, budgetFieldValue) {
    var qL = query.toLowerCase();
    var maxPrice = null;
    var minPrice = null;
    var qualityIntent = null;
    var source = null;

    if (/\b(cheap|budget|affordable|economical)\b/.test(qL)) qualityIntent = 'budget';
    else if (/\b(premium|professional|pro-grade|pro grade|trade grade|trade-grade|commercial)\b/.test(qL)) qualityIntent = 'premium';

    var patterns = [
      /under\s*\$?\s*(\d[\d,]*)/,
      /below\s*\$?\s*(\d[\d,]*)/,
      /less\s+than\s*\$?\s*(\d[\d,]*)/,
      /max\s*(?:imum)?\s*\$?\s*(\d[\d,]*)/,
      /\$(\d[\d,]*)\s*(?:or\s+)?(?:less|under|max(?:imum)?)/,
      /(\d[\d,]*)\s*(?:dollars?|bucks?)\s*(?:or\s+)?(?:under|less|max)/
    ];
    for (var pi = 0; pi < patterns.length; pi++) {
      var m = qL.match(patterns[pi]);
      if (m) { maxPrice = parseFloat(m[1].replace(/,/g, '')); source = 'query'; break; }
    }

    if (maxPrice === null && budgetFieldValue) {
      if (budgetFieldValue === 'under-200')  { maxPrice = 200;  minPrice = 0;    source = 'field'; }
      if (budgetFieldValue === '200-500')    { maxPrice = 500;  minPrice = 200;  source = 'field'; }
      if (budgetFieldValue === '500-1000')   { maxPrice = 1000; minPrice = 500;  source = 'field'; }
      if (budgetFieldValue === '1000-plus')  { maxPrice = null; minPrice = 1000; source = 'field'; }
    }

    var budget = (maxPrice !== null || minPrice !== null)
      ? { maxPrice: maxPrice, minPrice: minPrice || 0, source: source }
      : null;

    return { budget: budget, qualityIntent: qualityIntent };
  }

  // ── Budget scoring ───────────────────────────────────────────────────────────

  function getBudgetScore(price, budgetData, qualityIntent) {
    var p = parseFloat(price);
    if (isNaN(p)) return 0;

    var qualityBonus = 0;
    if (qualityIntent === 'budget')  { if (p < 200) qualityBonus = 3; else if (p > 500) qualityBonus = -2; }
    if (qualityIntent === 'premium') { if (p > 500) qualityBonus = 2; }

    if (!budgetData) return qualityBonus;

    var max = budgetData.maxPrice;
    var min = budgetData.minPrice || 0;

    if (max === null) return (p >= min ? 5 : 2) + qualityBonus; // $1000+ range: no upper cap

    if (p >= min && p <= max) return 5 + qualityBonus;  // within range
    if (p < min)              return 2 + qualityBonus;  // cheaper than range floor

    var over = (p - max) / max;
    if (over <= 0.2) return  2 + qualityBonus;
    if (over <= 0.5) return -5 + qualityBonus;
    return -10 + qualityBonus;
  }

  // ── Availability & inventory scoring ─────────────────────────────────────────

  function getAvailabilityInfo(product) {
    if (product.available === false) {
      return { availScore: -20, inventoryScore: 0, inventoryLevel: 'out' };
    }

    var totalInventory = 0;
    var hasData = false;
    if (product.variants) {
      product.variants.forEach(function (v) {
        if (typeof v.inventory_quantity === 'number') {
          totalInventory += v.inventory_quantity;
          hasData = true;
        }
      });
    }

    var inventoryScore = 0;
    var inventoryLevel = 'unknown';
    if (hasData) {
      if (totalInventory > 10)      { inventoryScore = 3; inventoryLevel = 'high'; }
      else if (totalInventory >= 1) { inventoryScore = 1; inventoryLevel = 'low';  }
    }

    return { availScore: 5, inventoryScore: inventoryScore, inventoryLevel: inventoryLevel };
  }

  // ── Trade scoring ─────────────────────────────────────────────────────────────

  function getTradeScore(product, tradeType) {
    if (!tradeType || tradeType === 'general') return 0;
    if (typeof TRADE_TOOL_MAP === 'undefined') return 0;
    var types = TRADE_TOOL_MAP[tradeType];
    if (!types) return 0;

    var typeL  = (product.type  || '').toLowerCase();
    var titleL = (product.title || '').toLowerCase();
    var tags   = product.tags   || [];

    for (var i = 0; i < types.length; i++) {
      var t = types[i].toLowerCase();
      if (typeL.indexOf(t) >= 0 || titleL.indexOf(t) >= 0) return 5;
      for (var j = 0; j < tags.length; j++) {
        if (tags[j].toLowerCase().indexOf(t) >= 0) return 5;
      }
    }
    return 0;
  }

  // ── Best Value marker ─────────────────────────────────────────────────────────

  function markBestValue(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].product.available !== false) {
        entries[i].isBestValue = true;
        return;
      }
    }
  }

  // ── Product type scoring ──────────────────────────────────────────────────────

  function getProductTypeScore(productType, intentLabel) {
    if (!productType || !intentLabel || typeof AI_PRODUCT_TYPES === 'undefined') return 0;
    var types = AI_PRODUCT_TYPES[intentLabel];
    if (!types) return 0;
    var tl = productType.toLowerCase();
    for (var i = 0; i < types.length; i++) {
      var pt = types[i].toLowerCase();
      if (tl === pt) return 5;
      if (tl.indexOf(pt) >= 0 || pt.indexOf(tl) >= 0) return 4;
    }
    return 0;
  }

  // ── Tag scoring ───────────────────────────────────────────────────────────────

  function getTagScore(tags, intentLabel) {
    if (!tags || !tags.length || !intentLabel) return 0;
    var iL = intentLabel.toLowerCase();
    var score = 0;
    tags.forEach(function (tag) {
      var tl = tag.toLowerCase().replace(/-/g, ' ');
      if (iL.indexOf(tl) >= 0 || tl.indexOf(iL) >= 0) score += 3;
    });
    return Math.min(score, 9);
  }

  // ── Intent expansion (Phase 2.5 + brand auto-detect) ─────────────────────────

  function expandQueryToTerms(query, brand, power, trade) {
    var qL = query.toLowerCase();
    var matchedKeys = [];
    var baseTerms = [];

    // Auto-detect known brand from query text if brand field is empty
    var effectiveBrand = brand;
    if (!effectiveBrand && typeof AI_BRANDS !== 'undefined') {
      for (var b = 0; b < AI_BRANDS.length; b++) {
        if (qL.indexOf(AI_BRANDS[b].toLowerCase()) >= 0) {
          effectiveBrand = AI_BRANDS[b];
          break;
        }
      }
    }

    if (typeof AI_TOOL_KEYWORDS !== 'undefined') {
      Object.keys(AI_TOOL_KEYWORDS).forEach(function (key) {
        if (qL.indexOf(key) >= 0) {
          matchedKeys.push(key);
          AI_TOOL_KEYWORDS[key].forEach(function (term) {
            if (baseTerms.indexOf(term) === -1) baseTerms.push(term);
          });
        }
      });
    }

    if (baseTerms.length === 0) baseTerms = [query];

    // Inject trade-specific tool terms when a trade is selected
    if (trade && trade !== 'general' && typeof TRADE_TOOL_MAP !== 'undefined' && TRADE_TOOL_MAP[trade]) {
      TRADE_TOOL_MAP[trade].slice(0, 2).forEach(function (t) {
        if (baseTerms.indexOf(t) === -1) baseTerms.push(t);
      });
    }

    var terms = baseTerms.slice(0, 6);

    if (effectiveBrand) terms.unshift(effectiveBrand + ' ' + baseTerms[0]);
    if (power && power !== 'either') terms.unshift(power + ' ' + baseTerms[0]);

    var seenT = {};
    var unique = [];
    terms.forEach(function (t) {
      if (!seenT[t]) { seenT[t] = true; unique.push(t); }
    });
    unique = unique.slice(0, 8);

    var label = '';
    if (matchedKeys.length > 0) {
      var sorted = matchedKeys.slice().sort(function (a, b) { return b.length - a.length; });
      label = (typeof AI_INTENT_LABELS !== 'undefined' && AI_INTENT_LABELS[sorted[0]])
        ? AI_INTENT_LABELS[sorted[0]]
        : sorted[0];
    }

    return { terms: unique, label: label, brand: effectiveBrand };
  }

  // ── Single-term search ────────────────────────────────────────────────────────

  function searchTerm(term) {
    return fetch(
      '/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=6'
    )
      .then(function (r) {
        if (!r.ok) throw new Error('Search failed');
        return r.json();
      })
      .then(function (data) {
        return {
          term: term,
          products: (data.resources && data.resources.results && data.resources.results.products) || []
        };
      })
      .catch(function () { return { term: term, products: [] }; });
  }

  // ── Enhanced merge & rank ─────────────────────────────────────────────────────

  function mergeAndRank(results, query, brand, intentLabel) {
    var seen = {};
    var scored = [];
    var qL = query.toLowerCase();

    results.forEach(function (result) {
      result.products.forEach(function (product) {
        if (seen[product.id]) {
          seen[product.id].termHits++;
          seen[product.id].score++;
        } else {
          var entry = {
            product: product,
            score: 1, termHits: 1,
            titleScore: 0, typeScore: 0, vendorScore: 0,
            tagScore: 0, bonusScore: 0, featuredScore: 0, imageScore: 0,
            availScore: 0, inventoryScore: 0, budgetScore: 0, tradeScore: 0,
            inventoryLevel: 'unknown', isBestValue: false,
            bonusInfo: null, isFeatured: false
          };
          seen[product.id] = entry;
          scored.push(entry);
        }
      });
    });

    scored.forEach(function (entry) {
      var p = entry.product;
      var tL  = (p.title  || '').toLowerCase();
      var vL  = (p.vendor || '').toLowerCase();
      var tags = p.tags || [];

      // Title word match: +2 per significant query word in title
      qL.split(/\s+/).forEach(function (w) {
        if (w.length > 3 && tL.indexOf(w) >= 0) entry.titleScore += 2;
      });

      // Product type match: +5 exact, +4 partial (collection-level)
      entry.typeScore = getProductTypeScore(p.type, intentLabel);

      // Vendor match: +10 if vendor matches preferred brand
      if (brand && vL.indexOf(brand.toLowerCase()) >= 0) entry.vendorScore = 10;

      // Tag score: +3 per tag aligning with intent (capped at +9)
      entry.tagScore = getTagScore(tags, intentLabel);

      // Bonus detection from tags
      var bonus = detectBonusFromTags(tags);
      if (bonus) {
        entry.bonusInfo  = bonus;
        entry.bonusScore = bonus.score;
      }

      // Featured detection from tags
      if (detectFeaturedFromTags(tags)) {
        entry.isFeatured     = true;
        entry.featuredScore  = 5;
      }

      // Availability & inventory scoring
      var availInfo = getAvailabilityInfo(p);
      entry.availScore     = availInfo.availScore;
      entry.inventoryScore = availInfo.inventoryScore;
      entry.inventoryLevel = availInfo.inventoryLevel;

      // Budget scoring
      entry.budgetScore = getBudgetScore(p.price, currentBudgetData, currentQualityIntent);

      // Trade scoring
      entry.tradeScore = getTradeScore(p, currentTrade);

      entry.score = entry.termHits + entry.titleScore + entry.typeScore
        + entry.vendorScore + entry.tagScore + entry.bonusScore + entry.featuredScore
        + entry.availScore + entry.inventoryScore + entry.budgetScore + entry.tradeScore;
    });

    // Image quality pass: +2 if image exists; -5 if missing (only when alternatives with images exist)
    var productsWithImages = scored.filter(function (e) {
      return !!(e.product.featured_image && e.product.featured_image.url);
    }).length;
    scored.forEach(function (e) {
      if (e.product.featured_image && e.product.featured_image.url) {
        e.imageScore = 2;
      } else if (productsWithImages > 0) {
        e.imageScore = -5;
      }
      e.score += e.imageScore;
    });

    scored.sort(function (a, b) { return b.score - a.score; });

    if (DEBUG) {
      var table = scored.slice(0, 10).map(function (e) {
        return {
          title:      e.product.title.slice(0, 40),
          total:      e.score,
          confidence: getConfidence(e.score).label,
          terms:      e.termHits,
          title_w:    e.titleScore,
          type:       e.typeScore,
          vendor:     e.vendorScore,
          tags:       e.tagScore,
          bonus:      e.bonusScore,
          featured:   e.featuredScore,
          image:      e.imageScore,
          avail:      e.availScore,
          inventory:  e.inventoryScore,
          budget:     e.budgetScore,
          trade:      e.tradeScore
        };
      });
      console.log('[AI Tool Finder] --- Ranking scores ---');
      console.table(table);
    }

    return scored.slice(0, 12);
  }

  // ── Categorise results ────────────────────────────────────────────────────────

  function categorise(entries) {
    var buckets = { featured: [], promotions: [], recommended: [] };

    entries.forEach(function (e) {
      if (e.isFeatured) {
        buckets.featured.push(e);
      } else if (e.bonusInfo) {
        buckets.promotions.push(e);
      } else {
        buckets.recommended.push(e);
      }
    });

    buckets.featured     = buckets.featured.slice(0, 3);
    buckets.promotions   = buckets.promotions.slice(0, 3);
    buckets.recommended  = buckets.recommended.slice(0, 6);

    if (buckets.recommended.length === 0 && entries.length > 0) {
      buckets.recommended = entries.slice(0, 3);
    }

    return buckets;
  }

  // ── Recommendation reasons ────────────────────────────────────────────────────

  function buildReasons(entry) {
    var reasons = [];
    var p = entry.product;

    if (currentBrand && entry.vendorScore > 0) {
      reasons.push('Matches ' + escapeHtml(getDisplayVendor(p.vendor)) + ' preference');
    }
    if (entry.typeScore >= 4 && p.type) {
      reasons.push(escapeHtml(p.type));
    }
    if (currentIntentLabel && (entry.titleScore > 0 || entry.typeScore >= 4)) {
      reasons.push('Suitable for ' + escapeHtml(currentIntentLabel));
    }
    if (entry.bonusInfo) {
      reasons.push(entry.bonusInfo.emoji + ' ' + escapeHtml(entry.bonusInfo.type) + ' offer');
    }
    if (entry.isFeatured) {
      reasons.push('Featured product');
    }
    if (entry.budgetScore >= 5) {
      reasons.push('Within your budget');
    }
    if (entry.tradeScore > 0 && currentTrade && currentTrade !== 'general') {
      var tradeLabel = currentTrade.charAt(0).toUpperCase() + currentTrade.slice(1);
      reasons.push('Suited to ' + tradeLabel + ' work');
    }
    if (entry.inventoryLevel === 'low') {
      reasons.push('Limited stock — order soon');
    } else if (entry.availScore > 0 && entry.inventoryLevel === 'high') {
      reasons.push('In stock');
    }

    return reasons.slice(0, 4);
  }

  // ── Build a single product card element ──────────────────────────────────────

  function buildCard(entry) {
    var p = entry.product;
    var price    = p.price;
    var compare  = p.compare_at_price_min;
    var onSale   = compare && parseFloat(compare) > 0 && parseFloat(compare) > parseFloat(price);

    var imgSrc = p.featured_image && p.featured_image.url
      ? shopifyImgUrl(p.featured_image.url, 300)
      : '';

    var priceHtml = '';
    if (onSale) {
      priceHtml = '<s class="atf-card__price-was">$' + escapeHtml(compare) + '</s>'
        + '<span class="atf-card__price atf-card__price--sale">$' + escapeHtml(price) + '</span>';
    } else if (price) {
      priceHtml = '<span class="atf-card__price">$' + escapeHtml(price) + '</span>';
    }

    var promoHtml = '';
    if (entry.bonusInfo) {
      var bi = entry.bonusInfo;
      promoHtml = '<div class="atf-card__promo-badge" style="--promo-color:' + bi.color + ';--promo-bg:' + bi.bg + '">'
        + '<span class="atf-card__promo-emoji" aria-hidden="true">' + bi.emoji + '</span>'
        + '<span>' + escapeHtml(bi.type) + '</span>'
        + '</div>';
    }

    var featuredHtml = entry.isFeatured
      ? '<span class="atf-card__featured-badge">⭐ Featured</span>'
      : '';

    var bestValueHtml = entry.isBestValue
      ? '<span class="atf-card__best-value">Best Value</span>'
      : '';

    var stockHtml = '';
    if (entry.inventoryLevel === 'out' || p.available === false) {
      stockHtml = '<span class="atf-card__stock atf-card__stock--out">Out of stock</span>';
    } else if (entry.inventoryLevel === 'low') {
      stockHtml = '<span class="atf-card__stock atf-card__stock--low">Low stock</span>';
    } else if (entry.inventoryLevel === 'high') {
      stockHtml = '<span class="atf-card__stock atf-card__stock--in">In stock</span>';
    }

    var conf = getConfidence(entry.score);
    var confHtml = '<span class="atf-confidence ' + conf.cls + '">'
      + (conf.emoji ? conf.emoji + ' ' : '') + escapeHtml(conf.label)
      + '</span>';

    var reasons = buildReasons(entry);
    var reasonsHtml = '';
    if (reasons.length > 0) {
      reasonsHtml = '<ul class="atf-reasons" aria-label="Why recommended">'
        + reasons.map(function (r) { return '<li>✓ ' + r + '</li>'; }).join('')
        + '</ul>';
    }

    var firstVariant = p.variants && p.variants[0];
    var variantId    = firstVariant ? firstVariant.id : null;
    var available    = p.available !== false;
    var atcHtml = variantId
      ? '<button type="button" class="atf-card__atc"'
          + ' data-variant-id="' + variantId + '"'
          + ' data-product-id="' + p.id + '"'
          + ' data-product-title="' + escapeHtml(p.title) + '"'
          + (available ? '' : ' disabled aria-disabled="true"')
          + ' aria-label="Add ' + escapeHtml(p.title) + ' to cart">'
          + (available ? 'Add to Cart' : 'Sold Out')
        + '</button>'
      : '';

    var trackAttrs = ' data-track-id="' + p.id + '" data-track-title="' + escapeHtml(p.title) + '"';

    var wrap = document.createElement('div');
    wrap.className = 'atf-card';
    wrap.innerHTML =
      '<a class="atf-card__img-wrap" href="' + escapeHtml(p.url) + '" tabindex="-1" aria-hidden="true"' + trackAttrs + '>'
        + (imgSrc
          ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="150" height="150">'
          : (placeholderImgUrl
              ? '<img src="' + escapeHtml(placeholderImgUrl) + '" alt="Image coming soon for ' + escapeHtml(p.title) + '" class="atf-card__img-placeholder" loading="lazy" width="150" height="150">'
              : '<div class="atf-card__img-placeholder"></div>'))
        + featuredHtml
        + bestValueHtml
      + '</a>'
      + '<div class="atf-card__body">'
        + confHtml
        + '<p class="atf-card__vendor">' + escapeHtml(getDisplayVendor(p.vendor)) + '</p>'
        + promoHtml
        + stockHtml
        + '<a class="atf-card__title" href="' + escapeHtml(p.url) + '"' + trackAttrs + '>'
            + escapeHtml(p.title)
          + '</a>'
        + reasonsHtml
        + '<div class="atf-card__price-row">' + priceHtml + '</div>'
        + '<div class="atf-card__footer">'
          + '<a class="atf-card__view" href="' + escapeHtml(p.url) + '"' + trackAttrs + '>View Product</a>'
          + atcHtml
        + '</div>'
      + '</div>';

    return wrap;
  }

  // ── Render category sections ──────────────────────────────────────────────────

  function clearCategories() {
    Object.keys(cats).forEach(function (k) {
      if (cats[k].grid)    cats[k].grid.innerHTML = '';
      if (cats[k].section) cats[k].section.hidden = true;
    });
    if (brandNote) { brandNote.hidden = true; brandNote.innerHTML = ''; }
  }

  function fillCategory(key, entries) {
    var cat = cats[key];
    if (!cat || !cat.grid || !cat.section || !entries.length) return;
    entries.forEach(function (e) { cat.grid.appendChild(buildCard(e)); });
    cat.section.hidden = false;
  }

  function renderResults(entries, query, intentLabel, brand, bestTerm) {
    // Set context used by buildCard / buildReasons
    currentIntentLabel = intentLabel || '';
    currentBrand       = brand || '';
    // currentTrade, currentBudget, currentBudgetData, currentQualityIntent set in handleSubmit

    markBestValue(entries);
    clearCategories();

    if (resultsHeading) {
      resultsHeading.textContent = intentLabel
        ? 'Recommended matches for ' + intentLabel
        : 'Suggested products';
    }
    updateSearchLinks(bestTerm || query);

    // Brand match check → show suggestion note if no match
    if (brand && brandNote) {
      var bL  = brand.toLowerCase();
      var hit = entries.some(function (e) {
        return isValidVendor(e.product.vendor)
          && e.product.vendor.toLowerCase().indexOf(bL) >= 0;
      });
      if (!hit) {
        var altBrands = [];
        entries.forEach(function (e) {
          var v = e.product.vendor;
          if (isValidVendor(v) && altBrands.indexOf(v) === -1 && altBrands.length < 3) {
            altBrands.push(v);
          }
        });
        var capBrand = brand.charAt(0).toUpperCase() + brand.slice(1);
        var noteHtml = 'No exact <strong>' + escapeHtml(capBrand) + '</strong> matches found.';
        if (altBrands.length > 0) {
          noteHtml += '<br>Similar products from:<ul class="atf-brand-note__list">'
            + altBrands.map(function (b) { return '<li>' + escapeHtml(b) + '</li>'; }).join('')
            + '</ul>';
        }
        brandNote.innerHTML = noteHtml;
        brandNote.hidden = false;
      }
    }

    var buckets = categorise(entries);
    fillCategory('recommended', buckets.recommended);
    fillCategory('promotions',  buckets.promotions);
    fillCategory('featured',    buckets.featured);

    var total = buckets.recommended.length + buckets.promotions.length + buckets.featured.length;

    setResponseState(total > 0 ? 'results' : 'no-results');
  }

  // ── Add to Cart ───────────────────────────────────────────────────────────────

  function addToCart(variantId, productTitle, productId, button) {
    trackATC(productId, productTitle);

    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        if (button) {
          button.textContent = '✓ Added';
          button.classList.add('atf-card__atc--added');
          window.setTimeout(function () {
            button.textContent = 'Add to Cart';
            button.classList.remove('atf-card__atc--added');
            button.disabled = false;
          }, 2000);
        }
        return fetch('/cart/count.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.querySelectorAll('.cart-count, [data-cart-count], .header__cart-count').forEach(function (el) {
          el.textContent = data.count;
          el.hidden = data.count === 0;
        });
      })
      .catch(function () {
        if (button) { button.textContent = 'Add to Cart'; button.disabled = false; }
      });
  }

  // ── Analytics ─────────────────────────────────────────────────────────────────

  function getStore() {
    try {
      var raw = localStorage.getItem(ANALYTICS_KEY);
      var s = raw ? JSON.parse(raw) : { searches: [], clicks: [], atcClicks: [] };
      if (!s.atcClicks) s.atcClicks = [];
      return s;
    } catch (e) { return { searches: [], clicks: [], atcClicks: [] }; }
  }

  function saveStore(store) {
    try { localStorage.setItem(ANALYTICS_KEY, JSON.stringify(store)); } catch (e) {}
  }

  function trackSearch(query, intent, terms, count, brand, trade, budget) {
    var store = getStore();
    store.searches.unshift({
      ts: Date.now(), query: query, intent: intent, terms: terms, count: count,
      brand: brand || '', trade: trade || '', budget: budget || ''
    });
    if (store.searches.length > 50) store.searches = store.searches.slice(0, 50);
    saveStore(store);
  }

  function trackClick(productId, productTitle) {
    var store = getStore();
    store.clicks.unshift({ ts: Date.now(), productId: productId, title: productTitle, query: lastQuery });
    if (store.clicks.length > 200) store.clicks = store.clicks.slice(0, 200);
    saveStore(store);
  }

  function trackATC(productId, productTitle) {
    var store = getStore();
    store.atcClicks.unshift({ ts: Date.now(), productId: productId, title: productTitle, query: lastQuery });
    if (store.atcClicks.length > 200) store.atcClicks = store.atcClicks.slice(0, 200);
    saveStore(store);
  }

  // ── Form submit ───────────────────────────────────────────────────────────────

  function handleSubmit(event) {
    event.preventDefault();
    if (!jobInput) return;

    var query = jobInput.value.trim();
    if (query.length < 3) {
      setResponseState('empty');
      jobInput.focus();
      return;
    }

    var brandInput  = document.getElementById('ai-tool-finder-brand');
    var powerSelect = document.getElementById('ai-tool-finder-power');
    var tradeSelect = document.getElementById('ai-tool-finder-trade');
    var budgetSelect = document.getElementById('ai-tool-finder-budget');
    var brand  = brandInput  && brandInput.value.trim()  ? brandInput.value.trim()  : '';
    var power  = powerSelect  ? powerSelect.value  : 'either';
    currentTrade  = tradeSelect  ? tradeSelect.value  : 'general';
    currentBudget = budgetSelect ? budgetSelect.value : '';

    var budgetExtract = extractBudget(query, currentBudget);
    currentBudgetData    = budgetExtract.budget;
    currentQualityIntent = budgetExtract.qualityIntent;

    var expanded = expandQueryToTerms(query, brand, power, currentTrade);
    var effectiveBrand = expanded.brand || brand;
    var bestTerm = expanded.terms.length > 0 ? expanded.terms[0] : query;
    lastQuery = query;

    if (DEBUG) {
      console.log('[AI Tool Finder] ═══ DEBUG MODE ═══');
      console.log('[AI Tool Finder] Query:', query);
      console.log('[AI Tool Finder] Brand (form):', brand || '(none)', '│ Auto-detected:', expanded.brand || '(none)', '│ Power:', power);
      console.log('[AI Tool Finder] Trade:', currentTrade, '│ Budget field:', currentBudget, '│ Budget data:', currentBudgetData, '│ Quality intent:', currentQualityIntent || '(none)');
      console.log('[AI Tool Finder] Intent detected:', expanded.label || '(none)');
      console.log('[AI Tool Finder] Expanded terms (' + expanded.terms.length + '):', expanded.terms);
      console.log('[AI Tool Finder] Selected search URL: /search?q=' + encodeURIComponent(bestTerm));
    }

    updateSearchLinks(bestTerm);
    setResponseState('loading');

    Promise.all(expanded.terms.map(searchTerm))
      .then(function (results) {
        var entries = mergeAndRank(results, query, effectiveBrand, expanded.label);

        if (DEBUG) {
          console.log('[AI Tool Finder] Products after merge/rank:', entries.length);
          var allUnique = [];
          results.forEach(function (r) {
            r.products.forEach(function (p) {
              if (!allUnique.some(function (x) { return x.id === p.id; })) allUnique.push(p);
            });
          });
          console.log('[AI Tool Finder] ─── Data Quality Report ─────────────────');
          console.log('[AI Tool Finder] Total unique products found:', allUnique.length);
          console.log('[AI Tool Finder] Missing images:', allUnique.filter(function (p) { return !p.featured_image || !p.featured_image.url; }).length);
          console.log('[AI Tool Finder] Missing/invalid vendors:', allUnique.filter(function (p) { return !isValidVendor(p.vendor); }).length);
          console.log('[AI Tool Finder] Missing product types:', allUnique.filter(function (p) { return !p.type || p.type.trim() === ''; }).length);
          console.log('[AI Tool Finder] ──────────────────────────────────────────');
        }

        trackSearch(query, expanded.label, expanded.terms, entries.length, effectiveBrand, currentTrade, currentBudget);

        if (entries.length === 0) {
          setResponseState('no-results');
        } else {
          renderResults(entries, query, expanded.label, effectiveBrand, bestTerm);
        }
      })
      .catch(function () { setResponseState('error'); });
  }

  // ── Example pills ─────────────────────────────────────────────────────────────

  function setExample(value) {
    if (!jobInput) return;
    jobInput.value = value;
    jobInput.focus();
    setResponseState('empty');
  }

  // ── Event listeners ───────────────────────────────────────────────────────────

  if (openBtn)       openBtn.addEventListener('click',       function () { setModalOpen(true);  });
  if (mobileOpenBtn) mobileOpenBtn.addEventListener('click', function () { setModalOpen(true);  });

  modal.querySelectorAll('[data-ai-tool-finder-close]').forEach(function (el) {
    el.addEventListener('click', function () { setModalOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') setModalOpen(false);
  });

  exampleButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { setExample(btn.textContent.trim()); });
  });

  if (form) form.addEventListener('submit', handleSubmit);

  // Delegated ATC + click-tracking inside modal
  modal.addEventListener('click', function (event) {
    // Add to Cart
    var atcBtn = event.target.closest('[data-variant-id]');
    if (atcBtn) {
      event.preventDefault();
      addToCart(atcBtn.dataset.variantId, atcBtn.dataset.productTitle, atcBtn.dataset.productId, atcBtn);
      return;
    }
    // Product click tracking (img link, title link, view button)
    var trackEl = event.target.closest('[data-track-id]');
    if (trackEl) {
      trackClick(trackEl.dataset.trackId, trackEl.dataset.trackTitle);
    }
  });

  setResponseState('empty');
});
